import config from '../../config';

import { invokeApig } from '../../utils/awsLib';

import * as endpoints from '../../endpoints';

import { authenticateCurrentUser } from '../authenticate/actions';

import * as types from './types';
import * as checkStatus from './status';

export const DSR_STATUS_NEW = 'new';
export const DSR_STATUS_RECEIVED = 'request_mhub_ctos_received';
export const DSR_STATUS_BAD_REQUEST = 'request_ctos_bad_request';
export const DSR_STATUS_REQUEST_TIMEOUT = 'request_ctos_timeout';
export const DSR_STATUS_AWAIT_MULTI_ENTITY = 'await_multi_entity';
export const DSR_STATUS_RESPOND_MULTI_ENTITY = 'request_ctos_muliple_entities';
export const DSR_STATUS_SUCCESS = 'request_success'; // CCRIS + DSR complete
export const DSR_STATUS_FAILURE = 'request_ctos_failure';

function getListRequest() {
  return {
    type: types.LIST_REQUEST,
  };
}

function getListSuccess(status, checks) {
  return {
    type: types.LIST_SUCCESS,
    payload: {
      status,
      checks,
    },
  };
}

function getListFailure(status, checks) {
  return {
    type: types.LIST_FAILURE,
    payload: {
      status,
      checks,
    },
  };
}

export function getListCheck(body) {
  return async (dispatch) => {
    dispatch(getListRequest());
    const path = endpoints.CHECKS;
    let result;
    try {
      const token = await dispatch(authenticateCurrentUser());
      result = await invokeApig({
        path,
        gateway: config.apiGateway,
        method: 'POST',
        body,
      }, token);
    } catch (e) {
      console.log('getListCheck', e.message);
      dispatch(getListFailure(checkStatus.LIST_STATUS_ERROR, result));
      return checkStatus.LIST_STATUS_ERROR;
    }
    dispatch(getListSuccess(checkStatus.LIST_STATUS_OK, result));
    return checkStatus.LIST_STATUS_OK;
  };
}

// RUN A CHECK

function runCheckRequest() {
  return {
    type: types.RUNCHECK_REQUEST,
  };
}

function runCheckSuccess(status, runChecks) {
  return {
    type: types.RUNCHECK_SUCCESS,
    payload: {
      status,
      runChecks,
    },
  };
}

function runCheckFailure(status, runChecks) {
  return {
    type: types.RUNCHECK_FAILURE,
    payload: {
      status,
      runChecks,
    },
  };
}

export function runCheck(body) {
  return async (dispatch) => {
    dispatch(runCheckRequest());
    const path = endpoints.RUNCHECK;
    let result;
    try {
      const token = await dispatch(authenticateCurrentUser());
      result = await invokeApig({
        path,
        body,
        method: 'POST',
        gateway: config.apiGateway,
      }, token);
    } catch (e) {
      console.log('runcheck', e.message);
      dispatch(runCheckFailure(checkStatus.RUNCHECK_STATUS_ERROR, result));
      return checkStatus.RUNCHECK_STATUS_ERROR;
    }
    dispatch(runCheckSuccess(checkStatus.RUNCHECK_STATUS_OK, result));
    return checkStatus.RUNCHECK_STATUS_OK;
  };
}



// WEBPACK FOOTER //
// ./src/redux/list/actions.js